module.exports = __webpack_public_path__ + "img/event.9a0a856a.svg";